export const menuList = {
  LOGIN_AND_SECURITY: 'LoginAndSecurity',
  API_TOKEN: 'APIToken',
};

export const apiTokenStatus = {
  REVOKE: 'REVOKE',
  ENABLE: 'ENABLE',
  PENDING: 'PENDING',
};
